import { useCallback } from "react";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../../context";

import type { TransferInfo } from "../type";

export const DEFAULT_TRANSFER_INFO: TransferInfo = {
	bankAccountNumber: {
		isEdited: false,
		value: "",
	},
	bankAccountHolderName: {
		isEdited: true,
		value: "",
	},
	bankAccountType: {
		isEdited: false,
		value: "",
	},
	bankName: {
		isEdited: false,
		value: "",
	},
	branchName: {
		isEdited: false,
		value: "",
	},
};

const bankAccountTypeOptions = [
	{
		id: "bankAccountTypeOptions_1",
		label: "普通",
		value: "普通",
	},
	{
		id: "bankAccountTypeOptions_2",
		label: "当座",
		value: "当座",
	},
] satisfies FormOptionType[];

export const useReservationLocalPaymentCancelFeeTransferInfo = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { localPaymentCancelFeeTransferInfo } = viewModel;

	const createUpdatedTransferInfo = useCallback(
		(field: keyof TransferInfo, value: string) => {
			const updatedInfo = !localPaymentCancelFeeTransferInfo
				? {
						...DEFAULT_TRANSFER_INFO,
						[field]: {
							isEdited: true,
							value,
						},
					}
				: {
						...localPaymentCancelFeeTransferInfo,
						[field]: {
							isEdited: true,
							value,
						},
					};

			return updatedInfo;
		},
		[localPaymentCancelFeeTransferInfo],
	);

	const handleFieldChange = useCallback(
		(field: keyof TransferInfo) => (input: string) => {
			const updatedValue = createUpdatedTransferInfo(field, input);
			onSetViewModel([
				{
					key: "localPaymentCancelFeeTransferInfo",
					value: updatedValue,
				},
			]);
		},
		[createUpdatedTransferInfo, onSetViewModel],
	);

	const onSetBankAccountHolderName = handleFieldChange("bankAccountHolderName");
	const onSetBankAccountNumber = handleFieldChange("bankAccountNumber");
	const onSetBankAccountType = handleFieldChange("bankAccountType");
	const onSetBankName = handleFieldChange("bankName");
	const onSetBranchName = handleFieldChange("branchName");

	const isEdited = Object.values(localPaymentCancelFeeTransferInfo || {}).some((field) => field?.isEdited);

	const hasError = Object.values(localPaymentCancelFeeTransferInfo || {}).some((field) => field?.error);

	return {
		isEdited,
		hasError,
		localPaymentCancelFeeTransferInfo,
		onSetBankAccountHolderName,
		onSetBankAccountNumber,
		bankAccountTypeOptions,
		onSetBankAccountType,
		onSetBankName,
		onSetBranchName,
	};
};
